




























































import { defineComponent } from '@vue/composition-api';
import { useI18N } from '../../../composables/use-vue-i18n';
import { useConfigurationApi } from '../../../plugins/configuration';
import { SideNavigationQuickMenuState } from './types';

const OPEN_SEARCH_EVENT = 'openSearch';

export default defineComponent({
  emits: [OPEN_SEARCH_EVENT],
  setup(props, { emit }) {
    const i18n = useI18N();
    const { data } = useConfigurationApi();
    let state: SideNavigationQuickMenuState = {
      region: data.routes.regionPrefix,
      logoutUrl: data.routes.auth.logout,
      loginUrl: data.routes.auth.login,
    };

    const logout = () => {
      // Add the id_token parameter with the information from the localStorage
      const session = localStorage.getItem('gp-session');
      if (session) {
        const sessionData = JSON.parse(session);
        const logoutUrl = new URL(state.logoutUrl);
        logoutUrl.searchParams.append('id_token', sessionData.id_token);

        // TODO: Since we do not use the Keycloak JS logout here, we need to get rid of the local
        // storage this is not nice and should be reworked.
        localStorage.removeItem('gp-session');
        window.location.replace(logoutUrl.toString());
      }
    };

    if (data.customer != null) {
      state = {
        ...state,
        hasUser: true,
        isAdminUser: data.customer.is_admin,
        id: data.customer.id,
        avatarUrl: data.customer.avatarUrl,
        balance: data.payment.balance_formatted,
      };
    }

    return {
      state,
      i18n,
      emit,
      logout,
    };
  },
});
